// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sTPrQ","delete":"styles_delete__1APWj","update":"styles_update__3LnSz","add":"styles_add__3gGNL"};